/* IOS Configurator — modal controller. Each card = a STYLE (collection); cards embed
   every color variant as JSON in [data-sh-style-data]. Color cascades from a master
   dropdown + per-style overrides; the PDP source product/color/size seed the state. */
   (function () {
    'use strict';
  
    var modal = document.querySelector('[data-sh-configurator]');
    if (!modal) return;
  
    // Init once even if the script loads twice (duplicate handlers would double-fire).
    if (window.__shConfiguratorInit) return;
    window.__shConfiguratorInit = true;
  
    var body = document.body;
    var masterSelect = modal.querySelector('[data-sh-master-color]');
    var lastTrigger = null;
    var originalGroupOrder = null;

    var quickView = modal.querySelector('[data-sh-quickview]');
    var qvState = { images: [], index: 0 };
  
    var modalState = {
      masterColor: '',
      styleOverrides: {},
      sourceProductId: '',
      sourceColor: '',
      sourceSize: '',
      sourceStyle: '',
      recommendedSizes: {}, // { SUIT:'52', SHIRT:'M', … } from Kiwi/localStorage
      items: [] // chosen items (captured at add time): { key, style, groupId, variantId, image, title, color, size }
    };
  
    // ----- Init: parse each card's style data + wire its Farbe select -----
  
    function initCards() {
      var cards = modal.querySelectorAll('[data-sh-card]');
      for (var i = 0; i < cards.length; i++) initCard(cards[i]);
    }
  
    function initCard(card) {
      var scriptEl = card.querySelector('[data-sh-style-data]');
      if (scriptEl) {
        try {
          card._shStyle = JSON.parse(scriptEl.textContent);
        } catch (e) {
          card._shStyle = null;
        }
      }
      var colorSelect = card.querySelector('[data-sh-card-color]');
      if (colorSelect) colorSelect.addEventListener('change', onCardColorChange);
      var sizeSelect = card.querySelector('[data-sh-card-size]');
      if (sizeSelect) sizeSelect.addEventListener('change', onCardSizeChange);
    }
  
    function onCardColorChange(event) {
      var card = event.target.closest('[data-sh-card]');
      if (!card) return;
      var style = card.dataset.style;
      if (!style) return;
  
      modalState.styleOverrides[style] = event.target.value;
      updateCardDisplay(card);
      updateCardButtons(); // this card's color changed → reflect whether the new color is in the tray
      updateSelectionUI();
    }
  
    // If this card's product is already in the tray, changing the size updates that item
    // in place (so the final add uses the latest size). Only the current color is affected.
    function onCardSizeChange(event) {
      var card = event.target.closest('[data-sh-card]');
      if (!card) return;
      var d = cardDescriptor(card);
      var idx = findItemIndex(d.style, d.color);
      if (idx >= 0 && d.variantId) {
        modalState.items[idx].variantId = d.variantId;
        modalState.items[idx].size = d.size;
        updateSelectionUI();
      }
    }
  
    // ----- Color helpers -----
  
    function lookupColor(colorsMap, target) {
      if (!colorsMap || !target) return null;
      var key = String(target).toLowerCase().trim();
      for (var k in colorsMap) {
        if (Object.prototype.hasOwnProperty.call(colorsMap, k)
            && k.toLowerCase().trim() === key) {
          return colorsMap[k];
        }
      }
      return null;
    }
  
    // First color whose product has an in-stock variant (else the first color). Used as the
    // fallback for "always show" categories when the master color isn't available.
    function firstAvailableColor(styleData) {
      var firstKey = null;
      for (var k in styleData.colors) {
        if (!Object.prototype.hasOwnProperty.call(styleData.colors, k)) continue;
        if (firstKey === null) firstKey = k;
        var p = styleData.colors[k];
        if (p && Array.isArray(p.variants)) {
          for (var i = 0; i < p.variants.length; i++) {
            if (p.variants[i].available !== false) return k;
          }
        }
      }
      return firstKey;
    }
  
    // ----- Core: update a single card's displayed product -----
  
    // ----- Quick view (product gallery + title + subline) -----

    function openQuickView(card) {
      if (!quickView || !card || !card._shStyle) return;
      var product = lookupColor(card._shStyle.colors, card.dataset.color);
      if (!product) return;

      var images = (product.images && product.images.length)
        ? product.images
        : (product.image ? [{ src: product.image, ratio: null }] : []);
      qvState.images = images;
      qvState.index = 0;

      // Warm the browser cache so next/prev switches are instant.
      for (var n = 0; n < images.length; n++) {
        var pre = new Image();
        pre.src = images[n].src;
      }

      var titleEl = quickView.querySelector('[data-sh-qv-title]');
      if (titleEl) titleEl.textContent = product.title || '';
      var subEl = quickView.querySelector('[data-sh-qv-subtitle]');
      if (subEl) {
        subEl.textContent = product.desc || '';
        subEl.hidden = !product.desc;
      }

      renderQuickView();
      quickView.hidden = false;
    }

    function renderQuickView() {
      if (!quickView) return;
      var imgs = qvState.images;

      var current = imgs[qvState.index];
      var imgEl = quickView.querySelector('[data-sh-qv-image]');
      if (imgEl && current) {
        imgEl.setAttribute('src', current.src || '');
        // Size the box to the photo's real shape so it neither letterboxes nor crops.
        imgEl.style.aspectRatio = current.ratio ? String(current.ratio) : '3 / 4';
      }

      // Arrows clamp at the ends (no looping) — disabled at first/last.
      var prev = quickView.querySelector('[data-sh-qv-prev]');
      var next = quickView.querySelector('[data-sh-qv-next]');
      if (prev) prev.disabled = qvState.index <= 0;
      if (next) next.disabled = qvState.index >= imgs.length - 1;

      var dotsWrap = quickView.querySelector('[data-sh-qv-dots]');
      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        if (imgs.length > 1) {
          for (var i = 0; i < imgs.length; i++) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'sh-configurator__qv-dot' + (i === qvState.index ? ' is-active' : '');
            dot.setAttribute('data-sh-qv-dot', i);
            dot.setAttribute('aria-label', String(i + 1));
            dotsWrap.appendChild(dot);
          }
        }
      }
    }

    function stepQuickView(dir) {
      var n = qvState.images.length;
      var next = qvState.index + dir;
      if (next < 0 || next > n - 1) return; // clamp at the ends
      qvState.index = next;
      renderQuickView();
    }

    function closeQuickView() {
      if (quickView) quickView.hidden = true;
    }

    function updateCardDisplay(card) {
      var styleData = card._shStyle;
      if (!styleData || !styleData.colors) {
        card.hidden = true;
        return;
      }
  
      var style = card.dataset.style;
      var grp = card.closest('[data-sh-group]');
      var groupDefault = grp ? grp.dataset.groupDefaultColor : '';
      // Per-card override wins; else the category's default color (if set); else master color.
      var color = modalState.styleOverrides[style] || groupDefault || modalState.masterColor;
  
      var product = lookupColor(styleData.colors, color);
      if (!product) {
        // "Always show" group: fall back to an available color instead of hiding.
        if (grp && grp.dataset.groupAlwaysShow === 'true') {
          color = firstAvailableColor(styleData);
          product = color ? lookupColor(styleData.colors, color) : null;
        }
        if (!product) {
          card.hidden = true;
          return;
        }
      }
  
      card.hidden = false;
  
      card.dataset.productId = product.id;
      card.dataset.productHandle = product.handle || '';
      card.dataset.productUrl = product.url || '';
      card.dataset.color = product.color || color;
  
      var imgEl = card.querySelector('[data-sh-card-image]');
      if (imgEl && product.image) {
        if (imgEl.getAttribute('src') !== product.image) {
          imgEl.removeAttribute('srcset');
          imgEl.setAttribute('src', product.image);
        }
        imgEl.setAttribute('alt', product.title || '');
      }
  
      var titleEl = card.querySelector('[data-sh-card-title]');
      if (titleEl) titleEl.textContent = product.title || '';
  
      var descEl = card.querySelector('[data-sh-card-desc]');
      if (descEl) descEl.textContent = product.desc || '';
  
      var priceEl = card.querySelector('[data-sh-card-price]');
      if (priceEl) priceEl.textContent = product.price || '';
  
      var colorSelect = card.querySelector('[data-sh-card-color]');
      if (colorSelect) setSelectByValueNoEvent(colorSelect, color);
  
      var sizeSelect = card.querySelector('[data-sh-card-size]');
      if (sizeSelect && Array.isArray(product.variants)) {
        var prevSize = sizeSelect.value;
        sizeSelect.innerHTML = '';
        var availableCount = 0;
        for (var i = 0; i < product.variants.length; i++) {
          var v = product.variants[i];
          var opt = document.createElement('option');
          opt.value = v.title;
          opt.textContent = v.title;
          opt.dataset.variantId = String(v.id);
          if (v.available === false) {
            opt.disabled = true; // sold-out size: shown greyed, can't be picked
          } else {
            availableCount++;
          }
          sizeSelect.appendChild(opt);
        }
  
        if (availableCount === 0) {
          // Every size sold out → whole product unavailable
          card.classList.add('is-sold-out');
          card.classList.remove('is-selected');
          if (sizeSelect.options.length) sizeSelect.selectedIndex = 0;
        } else {
          card.classList.remove('is-sold-out');
          // Prefer prev / source size (if in stock); else first available.
          // The Kiwi recommendation is shown as a line only — never auto-selected.
          if (!selectAvailableValue(sizeSelect, prevSize) &&
              !selectAvailableValue(sizeSelect, modalState.sourceSize)) {
            selectFirstAvailable(sizeSelect);
          }
        }
      }
  
      var atcBtn = card.querySelector('[data-sh-card-atc]');
      if (atcBtn) atcBtn.disabled = card.classList.contains('is-sold-out');
    }
  
    // ----- Master color dropdown -----
  
    function populateMasterColors() {
      if (!masterSelect) return;
      // Palette = source product's colors (matches the PDP picker); else union of all cards.
      var sourceCard = findSourceCard();
      var cards = (sourceCard && sourceCard._shStyle && sourceCard._shStyle.colors)
        ? [sourceCard]
        : modal.querySelectorAll('[data-sh-card]');
      var seen = {};
      var colors = [];
      for (var i = 0; i < cards.length; i++) {
        var styleData = cards[i]._shStyle;
        if (!styleData || !styleData.colors) continue;
        for (var c in styleData.colors) {
          if (!Object.prototype.hasOwnProperty.call(styleData.colors, c)) continue;
          var key = c.toLowerCase().trim();
          if (!seen[key]) { seen[key] = true; colors.push(c); }
        }
      }
      colors.sort(function (a, b) { return a.localeCompare(b); });
  
      masterSelect.innerHTML = '';
      for (var j = 0; j < colors.length; j++) {
        var opt = document.createElement('option');
        opt.value = colors[j];
        opt.textContent = colors[j];
        masterSelect.appendChild(opt);
      }
    }
  
    function setMasterColor(color) {
      if (!masterSelect || !color) return false;
      var target = String(color).toLowerCase().trim();
      for (var i = 0; i < masterSelect.options.length; i++) {
        if (masterSelect.options[i].value.toLowerCase().trim() === target) {
          masterSelect.selectedIndex = i;
          return true;
        }
      }
      var opt = document.createElement('option');
      opt.value = color;
      opt.textContent = color;
      opt.selected = true;
      masterSelect.appendChild(opt);
      return false;
    }
  
    // ----- Iterate every card; apply color + visibility + per-group cap -----
  
    function updateAllCards() {
      var groups = modal.querySelectorAll('[data-sh-group]');
  
      for (var g = 0; g < groups.length; g++) {
        var group = groups[g];
        var maxVisible = parseInt(group.dataset.groupMaxVisible, 10);
        if (isNaN(maxVisible) || maxVisible <= 0) maxVisible = Infinity;
        var visibleCount = 0;
  
        var cards = group.querySelectorAll('[data-sh-card]');
        for (var i = 0; i < cards.length; i++) {
          var card = cards[i];
  
          updateCardDisplay(card);
  
          if (!card.hidden) {
            if (visibleCount >= maxVisible) {
              card.hidden = true;
            } else {
              visibleCount++;
            }
          }
        }
  
        group.hidden = (visibleCount === 0);
      }
  
      updateCardButtons(); // mark cards whose current color is already in the tray
    }
  
    if (masterSelect) {
      masterSelect.addEventListener('change', function () {
        modalState.masterColor = masterSelect.value;
        modalState.styleOverrides = {}; // master wins — clear per-card overrides
        updateAllCards();
        updateSelectionUI();
      });
    }
  
    // ----- <select> helpers -----
  
    function setSelectByValueNoEvent(select, value) {
      if (!select || value == null) return false;
      var target = String(value).toLowerCase();
      var options = select.options;
      for (var i = 0; i < options.length; i++) {
        if (String(options[i].value).toLowerCase() === target) {
          select.selectedIndex = i;
          return true;
        }
      }
      return false;
    }
  
    // Select a value only if its option is in stock (not disabled).
    function selectAvailableValue(select, value) {
      if (!select || value == null) return false;
      var target = String(value).toLowerCase();
      for (var i = 0; i < select.options.length; i++) {
        var o = select.options[i];
        if (!o.disabled && String(o.value).toLowerCase() === target) {
          select.selectedIndex = i;
          return true;
        }
      }
      return false;
    }
  
    function selectFirstAvailable(select) {
      if (!select) return false;
      for (var i = 0; i < select.options.length; i++) {
        if (!select.options[i].disabled) {
          select.selectedIndex = i;
          return true;
        }
      }
      return false;
    }
  
    function applySourceSize(sourceSize) {
      if (!sourceSize) return;
      var cards = modal.querySelectorAll('[data-sh-card]');
      for (var i = 0; i < cards.length; i++) {
        if (cards[i].hidden) continue;
        // Only apply the source size where it's actually in stock for that card.
        selectAvailableValue(cards[i].querySelector('[data-sh-card-size]'), sourceSize);
      }
    }
  
    // ----- Source style / group helpers -----
  
    function captureOriginalGroupOrder() {
      if (originalGroupOrder) return;
      var bodyEl = modal.querySelector('[data-sh-configurator-body]');
      if (!bodyEl) return;
      originalGroupOrder = Array.prototype.slice.call(
        bodyEl.querySelectorAll('[data-sh-group]')
      );
    }
  
    function findSourceStyle() {
      var id = modalState.sourceProductId;
      if (!id) return '';
      var cards = modal.querySelectorAll('[data-sh-card]');
      for (var i = 0; i < cards.length; i++) {
        var styleData = cards[i]._shStyle;
        if (!styleData || !styleData.colors) continue;
        for (var c in styleData.colors) {
          if (!Object.prototype.hasOwnProperty.call(styleData.colors, c)) continue;
          if (String(styleData.colors[c].id) === String(id)) {
            return styleData.style || cards[i].dataset.style;
          }
        }
      }
      return '';
    }
  
    function resolveSizeFromVariantId(variantId) {
      if (!variantId) return '';
      var card = findSourceCard();
      if (!card || !card._shStyle || !card._shStyle.colors) return '';
      var colors = card._shStyle.colors;
      for (var c in colors) {
        if (!Object.prototype.hasOwnProperty.call(colors, c)) continue;
        var variants = colors[c].variants;
        if (!Array.isArray(variants)) continue;
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === String(variantId)) return variants[i].title;
        }
      }
      return '';
    }
  
    function findSourceCard() {
      if (!modalState.sourceStyle) return null;
      return modal.querySelector(
        '[data-sh-card][data-style="' + modalState.sourceStyle + '"]'
      );
    }
  
    function findSourceGroup() {
      var card = findSourceCard();
      return card ? card.closest('[data-sh-group]') : null;
    }
  
    function applyGroupOrder() {
      var bodyEl = modal.querySelector('[data-sh-configurator-body]');
      if (!bodyEl) return;
      captureOriginalGroupOrder();
      if (!originalGroupOrder) return;
      for (var i = 0; i < originalGroupOrder.length; i++) {
        bodyEl.appendChild(originalGroupOrder[i]);
      }
      var sourceGroup = findSourceGroup();
      if (sourceGroup) {
        bodyEl.insertBefore(sourceGroup, bodyEl.firstElementChild);
        // Within the source group, show the source style first, then its other styles.
        var sourceCard = findSourceCard();
        var cardsEl = sourceCard ? sourceCard.parentNode : null;
        if (cardsEl && cardsEl.firstElementChild !== sourceCard) {
          cardsEl.insertBefore(sourceCard, cardsEl.firstElementChild);
        }
      }
    }
  
    // ----- Read source product from CTA trigger -----
  
    function readSourceFromTrigger(trigger) {
      var form = trigger.closest('form') || document.querySelector('form[action*="/cart/add"]');
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var liveVariantId = idInput ? String(idInput.value || '') : '';
  
      return {
        productId: trigger.dataset.productId || '',
        variantId: liveVariantId || trigger.dataset.variantId || '',
        color:     trigger.dataset.color || '',
        size:      trigger.dataset.size  || ''
      };
    }
  
    // ----- Open / close -----
  
    function open(trigger) {
      lastTrigger = trigger || null;
  
      var source = trigger
        ? readSourceFromTrigger(trigger)
        : { productId: '', variantId: '', color: '', size: '' };
  
      modalState.sourceProductId = source.productId;
      modalState.sourceColor     = source.color;
      modalState.sourceSize      = source.size;
      modalState.sourceStyle     = findSourceStyle();
      modalState.masterColor     = source.color;
      modalState.styleOverrides  = {};
      // Load any previously-computed Kiwi sizes so the recommend lines show on open.
      modalState.recommendedSizes = (readStoredSizing() || {}).sizes || {};
  
      // data-size is the page-load variant; resolve the live size from the cart form's variant id.
      var liveSize = resolveSizeFromVariantId(source.variantId);
      if (liveSize) {
        modalState.sourceSize = liveSize;
        source.size = liveSize;
      }
  
      modal.dataset.sourceProductId = source.productId;
      modal.dataset.sourceVariantId = source.variantId;
      modal.dataset.sourceColor     = source.color;
      modal.dataset.sourceSize      = source.size;
  
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      body.classList.add('sh-configurator-open');
      // Recover from any interrupted Kiwi session that left the panel hidden.
      setConfiguratorVisible(true);
      kiwiState.measuring = false;
      kiwiState.session++; // cancel any in-flight run from a previous open
      if (kiwiPoll) { clearInterval(kiwiPoll); kiwiPoll = null; }
  
      applyGroupOrder();
      populateMasterColors();
      setMasterColor(source.color);
      updateAllCards();
      applySourceSize(source.size);
      applyRecommendations(); // toggle "Wir empfehlen Größe" lines from stored sizes
      ensureKiwiSubscription();
      refreshFromProfile();   // re-pull latest sizes from Kiwi's profile (PDP-set too)
      updateSelectionUI();
  
      var closeBtn = modal.querySelector('[data-sh-configurator-close]:not([aria-hidden])');
      if (closeBtn && typeof closeBtn.focus === 'function') closeBtn.focus();
  
      modal.dispatchEvent(new CustomEvent('sh-configurator:open', { detail: source }));
    }
  
    function close() {
      closeQuickView();
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      body.classList.remove('sh-configurator-open');
  
      clearItems();
      updateSelectionUI();
      setCheckoutError(false);
  
      if (masterSelect && masterSelect.options.length > 0) {
        masterSelect.selectedIndex = 0;
      }
  
      if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
      lastTrigger = null;
  
      modal.dispatchEvent(new CustomEvent('sh-configurator:close'));
    }
  
    function clearItems() {
      modalState.items = [];
      updateCardButtons();
    }
  
    // ----- Selection (captured-items model) -----
  
    // The card's current variant descriptor, captured when it's added to the tray.
    function cardDescriptor(card) {
      var sizeSelect = card.querySelector('[data-sh-card-size]');
      var sizeOpt = sizeSelect ? sizeSelect.options[sizeSelect.selectedIndex] : null;
      var img = card.querySelector('[data-sh-card-image]');
      var titleEl = card.querySelector('[data-sh-card-title]');
      var group = card.closest('[data-sh-group]');
      return {
        style: card.dataset.style || '',
        color: card.dataset.color || '',
        groupId: group ? (group.dataset.groupId || '') : '',
        variantId: sizeOpt && sizeOpt.dataset.variantId ? sizeOpt.dataset.variantId : '',
        size: sizeSelect ? sizeSelect.value : '',
        image: img ? (img.getAttribute('src') || '') : '',
        title: titleEl ? titleEl.textContent : ''
      };
    }
  
    // One tray item per style+color, so the same style can be added in different colors.
    function itemKey(style, color) { return style + '|' + color; }
  
    function findItemIndex(style, color) {
      var k = itemKey(style, color);
      for (var i = 0; i < modalState.items.length; i++) {
        if (modalState.items[i].key === k) return i;
      }
      return -1;
    }
  
    // Mark a card AUSGEWÄHLT when its currently-shown color is already in the tray.
    function updateCardButtons() {
      var cards = modal.querySelectorAll('[data-sh-card]');
      for (var i = 0; i < cards.length; i++) {
        var c = cards[i];
        c.classList.toggle('is-selected', findItemIndex(c.dataset.style || '', c.dataset.color || '') >= 0);
      }
    }
  
    // Add or remove the card's current variant. Same style + different color = a separate
    // item, so a customer can order e.g. a black AND a navy suit.
    function toggleCardItem(card) {
      if (card.classList.contains('is-sold-out')) return;
      var d = cardDescriptor(card);
      if (!d.variantId) return;
      var idx = findItemIndex(d.style, d.color);
      if (idx >= 0) {
        modalState.items.splice(idx, 1); // already chosen in this color → remove
      } else {
        // Every group allows multiple selections (mix products and colors freely).
        modalState.items.push({
          key: itemKey(d.style, d.color), style: d.style, groupId: d.groupId,
          variantId: d.variantId, image: d.image, title: d.title, color: d.color, size: d.size
        });
      }
      updateCardButtons();
      updateSelectionUI();
    }
  
    function updateSelectionUI() {
      var items = modalState.items;
      var tray = modal.querySelector('[data-sh-tray]');
      if (tray) {
        tray.innerHTML = '';
        // Always show at least 4 slots; once there are more chosen items the row scrolls.
        var slotCount = Math.max(5, items.length);
  
        for (var i = 0; i < slotCount; i++) {
          if (i < items.length) {
            var it = items[i];
            var el = document.createElement('div');
            el.className = 'sh-configurator__tray-item';
            el.innerHTML =
              (it.image ? '<img src="' + it.image + '" alt="">' : '') +
              '<button type="button" class="sh-configurator__tray-remove" data-sh-tray-remove data-key="' +
              (it.key + '').replace(/"/g, '&quot;') + '" aria-label="Entfernen">&minus;</button>';
            tray.appendChild(el);
          } else {
            var ph = document.createElement('div');
            ph.className = 'sh-configurator__tray-item sh-configurator__tray-item--empty';
            ph.innerHTML = '<svg class="sh-configurator__tray-plus" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/></svg>';
            tray.appendChild(ph);
          }
        }
        var wrap = modal.querySelector('[data-sh-tray-wrap]');
        if (wrap) wrap.hidden = false;
      }
  
      updateTrayArrows();
  
      var checkoutBtn = modal.querySelector('[data-sh-configurator-checkout]');
      if (checkoutBtn) checkoutBtn.disabled = items.length === 0;
    }
  
    function updateTrayArrows() {
      var wrap = modal.querySelector('[data-sh-tray-wrap]');
      var tray = modal.querySelector('[data-sh-tray]');
      if (!wrap || !tray) return;
      // Desktop arrows show only when the row actually overflows (CSS gates by viewport).
      var scrollable = tray.scrollWidth > tray.clientWidth + 2;
      wrap.classList.toggle('is-scrollable', scrollable);
    }
  
    function scrollTray(dir) {
      var tray = modal.querySelector('[data-sh-tray]');
      if (tray) tray.scrollBy({ left: dir * 150, behavior: 'smooth' });
    }
  
    function removeItemByKey(key) {
      for (var i = 0; i < modalState.items.length; i++) {
        if (modalState.items[i].key === key) { modalState.items.splice(i, 1); break; }
      }
      updateCardButtons();
      updateSelectionUI();
    }
  
    function setCheckoutError(show) {
      var el = modal.querySelector('[data-sh-checkout-error]');
      if (el) el.hidden = !show;
    }
  
    // Add the selected items to the cart (plain add), then close the modal and open the
    // theme's cart drawer. No checkout redirect.
    function addSelectedToCart() {
      var items = [];
      for (var i = 0; i < modalState.items.length; i++) {
        var vid = modalState.items[i].variantId;
        // Hidden line-item property so orders can be identified (Shopify Flow tags them).
        if (vid) items.push({ id: vid, quantity: 1, properties: { _via: 'Configurator' } });
      }
      if (items.length === 0) return;
  
      setCheckoutError(false);
      var btn = modal.querySelector('[data-sh-configurator-checkout]');
      if (btn) btn.disabled = true;
  
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart-add-failed');
        return r.json();
      }).then(function () {
        if (btn) btn.disabled = false;
        close(); // close the configurator modal
        // Refresh + open the theme's cart drawer (updates header count too).
        if (typeof window.refreshCart === 'function') {
          window.refreshCart();
        } else {
          window.location.href = '/cart';
        }
      }).catch(function () {
        setCheckoutError(true);
        if (btn) btn.disabled = false;
      });
    }
  
    // ----- Wiring -----
  
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-sh-configurator-open]');
      if (trigger) {
        event.preventDefault();
        open(trigger);
      }
    });
  
    modal.addEventListener('click', function (event) {
      if (event.target.closest('[data-sh-configurator-close]')) {
        event.preventDefault();
        close();
        return;
      }
      if (event.target.closest('[data-sh-quickview-close]')) {
        closeQuickView();
        return;
      }
      if (event.target.closest('[data-sh-qv-prev]')) { stepQuickView(-1); return; }
      if (event.target.closest('[data-sh-qv-next]')) { stepQuickView(1); return; }
      var qvDot = event.target.closest('[data-sh-qv-dot]');
      if (qvDot) {
        qvState.index = parseInt(qvDot.getAttribute('data-sh-qv-dot'), 10) || 0;
        renderQuickView();
        return;
      }
      var qvTrigger = event.target.closest('[data-sh-card-title], [data-sh-card-image]');
      if (qvTrigger) {
        var qvCard = qvTrigger.closest('[data-sh-card]');
        if (qvCard) openQuickView(qvCard);
        return;
      }
      var atc = event.target.closest('[data-sh-card-atc]');
      if (atc) {
        var card = atc.closest('[data-sh-card]');
        if (card) toggleCardItem(card);
        return;
      }
      var rm = event.target.closest('[data-sh-tray-remove]');
      if (rm) {
        removeItemByKey(rm.dataset.key);
        return;
      }
      if (event.target.closest('[data-sh-tray-prev]')) {
        scrollTray(-1);
        return;
      }
      if (event.target.closest('[data-sh-tray-next]')) {
        scrollTray(1);
        return;
      }
      if (event.target.closest('[data-sh-configurator-checkout]')) {
        addSelectedToCart();
      }
    });

    // Swipe the quick-view gallery on touch devices (arrows still work everywhere).
    (function () {
      if (!quickView) return;
      var gallery = quickView.querySelector('.sh-configurator__qv-gallery');
      if (!gallery) return;
      var startX = 0, startY = 0, tracking = false;
      gallery.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        tracking = true;
      }, { passive: true });
      gallery.addEventListener('touchend', function (e) {
        if (!tracking) return;
        tracking = false;
        var t = e.changedTouches[0];
        var dx = t.clientX - startX;
        var dy = t.clientY - startY;
        // Ignore taps and vertical scrolls; require a mostly-horizontal drag.
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        stepQuickView(dx < 0 ? 1 : -1);
      }, { passive: true });
    })();

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (modal.hidden) return;
      if (quickView && !quickView.hidden) { closeQuickView(); return; }
      close();
    });
  
    function focusableElements() {
      return modal.querySelectorAll(
        'a[href], button:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
    }
  
    modal.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;
      var focusables = focusableElements();
      if (focusables.length === 0) return;
      var first = focusables[0];
      var last  = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  
    // ===== Kiwi sizing =====
    // "Finde meine Größe" opens the PDP's Kiwi recommender; on close each category's size
    // comes from Kiwi's on_size_recommendation event (matched by chart id), is saved to
    // localStorage and shown as the per-group recommend line.
  
    var LS_KEY = 'sh_kiwi_sizes_v1';
  
    // `capture` holds the in-flight category's resolver + its size-chart id, so we accept
    // only that chart's recommendation (categories run one at a time). `session` is bumped
    // whenever a new flow starts; async work no-ops once superseded (so a click cancels a
    // background refresh instead of being blocked by it).
    var kiwiState = {
      subscribed: false,
      session: 0,           // generation counter; bumped per refresh/measure run
      measuring: false,     // user is in Kiwi's modal
      phase: 'idle',        // 'idle' | 'source' | 'category'
      pendingCategory: '',
      height: '',
      weight: '',
      sizes: {},
      capture: null         // { chartId, resolve } while computing one category
    };
  
    function readStoredSizing() {
      try {
        var raw = window.localStorage.getItem(LS_KEY);
        if (!raw) return null;
        var obj = JSON.parse(raw);
        return (obj && obj.sizes) ? obj : null;
      } catch (e) { return null; }
    }
  
    function writeStoredSizing(data) {
      try { window.localStorage.setItem(LS_KEY, JSON.stringify(data)); } catch (e) {}
    }
  
    function getGroups() {
      return Array.prototype.slice.call(modal.querySelectorAll('[data-sh-group]'));
    }
  
    function categoryOfGroup(group) {
      return (group.dataset.groupCategory || '').toUpperCase();
    }
  
    function sourceCategory() {
      var card = findSourceCard();
      var group = card ? card.closest('[data-sh-group]') : null;
      return group ? categoryOfGroup(group) : '';
    }
  
    function parseKiwiProduct(group) {
      var raw = group.dataset.kiwiProduct;
      if (!raw) return null;
      try { return JSON.parse(raw); } catch (e) { return null; }
    }
  
    // Toggle each group's recommend line (the size is shown, not auto-selected).
    function applyRecommendations() {
      var sizes = modalState.recommendedSizes || {};
      var groups = getGroups();
      for (var g = 0; g < groups.length; g++) {
        var group = groups[g];
        var cat = categoryOfGroup(group);
        var size = sizes[cat];
        var line = group.querySelector('[data-sh-recommend]');
        var sizeEl = group.querySelector('[data-sh-recommend-size]');
  
        if (size) {
          if (sizeEl) sizeEl.textContent = size;
          if (line) line.hidden = false;
        } else if (line) {
          line.hidden = true;
        }
      }
      updateSizeGuideLabel();
    }
  
    // "Finde meine Größe" → "Ändern" once any recommendation exists.
    function updateSizeGuideLabel() {
      var link = modal.querySelector('[data-sh-open-size-guide]');
      var span = link && link.querySelector('[data-sh-size-link-text]');
      if (!span) return;
      var sizes = modalState.recommendedSizes || {};
      var has = false;
      for (var k in sizes) { if (sizes[k]) { has = true; break; } }
      span.textContent = has
        ? (link.dataset.labelChange || 'Ändern')
        : (link.dataset.labelFind || 'Finde meine Größe');
    }
  
    // ----- Kiwi widget plumbing -----
  
    // The hidden host (#sh-kiwi-host) also renders Kiwi inputs; ignore those so we only
    // ever read the real, on-screen source modal.
    function liveKiwiInput(unit) {
      var nodes = document.querySelectorAll('.element-input[data-unit="' + unit + '"]');
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (el.closest('#sh-kiwi-host')) continue; // skip our hidden host
        // Skip Kiwi's hidden leftover recommenders — only the open modal's input is visible.
        if (el.offsetParent !== null || el.getClientRects().length > 0) return el;
      }
      return null;
    }
  
    function readKiwiInputs() {
      var cm = liveKiwiInput('cm');
      var kg = liveKiwiInput('kg');
      return { height: cm ? cm.value : '', weight: kg ? kg.value : '' };
    }
  
    // Read Kiwi's result text (whole, e.g. "46 I 48"); document-wide skips hidden leftovers.
    function scrapeSize(container) {
      var root = container || document;
      var els = root.querySelectorAll('.formula-element .formula-text, .formula-text');
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (root === document) {
          if (el.closest('#sh-kiwi-host')) continue; // skip our hidden host
          if (el.offsetParent === null && el.getClientRects().length === 0) continue; // skip hidden leftovers
        }
        var txt = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (txt) return txt;
      }
      return '';
    }
  
    function ensureKiwiSubscription() {
      if (kiwiState.subscribed || !window.ks || typeof window.ks.on !== 'function') return;
      // ks.on('modal_close', …) throws ("listener must be a function") — close is polled.
      try {
        window.ks.on('on_size_recommendation', onKiwiRecommendation);
        window.ks.on('sizing_loaded', onKiwiSizingLoaded);
        kiwiState.subscribed = true;
      } catch (e) { /* retry on next open */ }
    }
  
    // Records which size chart the in-flight category loadSizing matched.
    function onKiwiSizingLoaded(data) {
      if (kiwiState.capture && data && data.sizeChartID != null) {
        kiwiState.capture.chartId = data.sizeChartID;
      }
    }
  
    // Kiwi's modal opens beneath our z-index:99999 panel, so hide ours while measuring.
    function setConfiguratorVisible(visible) {
      modal.style.visibility = visible ? '' : 'hidden';
      modal.style.pointerEvents = visible ? '' : 'none';
    }
  
    // Kiwi modal open? liveKiwiInput only returns a VISIBLE (real modal) input.
    function kiwiModalOpen() {
      return liveKiwiInput('cm') !== null;
    }
  
    var kiwiPoll = null;
    // While Kiwi's modal is open, capture height/weight + source size; on close, proceed.
    function watchKiwiModal() {
      if (kiwiPoll) clearInterval(kiwiPoll);
      var sawOpen = false;
      var closedTicks = 0;
      kiwiPoll = setInterval(function () {
        if (kiwiModalOpen()) {
          sawOpen = true;
          closedTicks = 0;
          var hw = readKiwiInputs();
          if (hw.height) kiwiState.height = hw.height;
          if (hw.weight) kiwiState.weight = hw.weight;
          var s = scrapeSize(document);
          if (s && kiwiState.pendingCategory) kiwiState.sizes[kiwiState.pendingCategory] = s;
        } else if (sawOpen) {
          // 3 consecutive closed ticks: ignore the re-render flicker on height/weight change.
          closedTicks++;
          if (closedTicks >= 3) onKiwiClosed();
        }
      }, 400);
      setTimeout(function () { // give up if the modal never opened
        if (kiwiPoll && !sawOpen) { clearInterval(kiwiPoll); kiwiPoll = null; }
      }, 180000);
    }
  
    // Idempotent; fired by the poller or Kiwi's event.
    function onKiwiClosed() {
      if (!kiwiState.measuring) return;
      kiwiState.measuring = false;
      if (kiwiPoll) { clearInterval(kiwiPoll); kiwiPoll = null; }
      setConfiguratorVisible(true);
      kiwiState.phase = 'idle';
      // Let Kiwi persist the new measurements before category #1 reads its profile.
      setTimeout(runCategoryQueue, 600);
    }
  
    function onKiwiRecommendation(data) {
      var size = (data && data.status === 'has_size' && data.size) ? data.size : '';
  
      if (kiwiState.phase === 'source') {
        // Record only; other categories run on close (poller / onKiwiClosed).
        var hw = readKiwiInputs();
        if (hw.height) kiwiState.height = hw.height;
        if (hw.weight) kiwiState.weight = hw.weight;
        if (size && kiwiState.pendingCategory) kiwiState.sizes[kiwiState.pendingCategory] = size;
      } else if (kiwiState.phase === 'category' && kiwiState.capture && kiwiState.capture.chartId != null) {
        // Accept only the chart THIS category loaded, so a stray result can't land on it.
        if (String(data && data.id) === String(kiwiState.capture.chartId)) {
          kiwiState.capture.resolve(size);
        }
      }
    }
  
    var kiwiHost = null;
    function getHiddenKiwiHost() {
      if (kiwiHost && document.body.contains(kiwiHost)) return kiwiHost;
      kiwiHost = document.createElement('div');
      kiwiHost.id = 'sh-kiwi-host';
      kiwiHost.setAttribute('aria-hidden', 'true');
      // Offscreen but rendered — Kiwi won't compute inside display:none.
      kiwiHost.style.cssText =
        'position:fixed;left:-9999px;top:0;width:360px;height:1px;overflow:hidden;opacity:0;pointer-events:none;';
      document.body.appendChild(kiwiHost);
      return kiwiHost;
    }
  
    // loadSizing a category's rep product; capture its size from the matching event.
    function computeCategory(productData) {
      return new Promise(function (resolve) {
        if (!window.ks || typeof window.ks.loadSizing !== 'function') { resolve(''); return; }
  
        var host = getHiddenKiwiHost();
        host.innerHTML = '';
        var el = document.createElement('div');
        host.appendChild(el);
  
        ensureKiwiSubscription(); // event must reach onKiwiRecommendation
  
        var mySession = kiwiState.session;
        var settled = false;
        var timer = null;
        function finish(size) {
          if (settled) return;
          settled = true;
          if (timer) clearTimeout(timer);
          // Only touch shared state if this compute is still the current session —
          // otherwise a stale (superseded) compute would clobber a newer flow.
          if (mySession === kiwiState.session) {
            kiwiState.phase = 'idle';
            kiwiState.capture = null;
          }
          resolve(mySession === kiwiState.session ? (size || '') : '');
        }
  
        // Size arrives via on_size_recommendation (matched by chart id); the element stays empty.
        kiwiState.phase = 'category';
        kiwiState.capture = { chartId: null, resolve: finish };
  
        window.ks.loadSizing({
          productData: productData,
          options: { el: el, displayMode: 0 },
          loaded: function (success) {
            if (!success) { finish(''); return; }
            timer = setTimeout(function () { finish(''); }, 6000); // no event → give up
          }
        });
      });
    }
  
    // Walk every group except those already captured (source), one at a time.
    function runCategoryQueue() {
      var groups = getGroups();
      var jobs = [];
      var seenCat = {};
      for (var i = 0; i < groups.length; i++) {
        var cat = categoryOfGroup(groups[i]);
        if (!cat || seenCat[cat] || kiwiState.sizes[cat]) continue;
        var pd = parseKiwiProduct(groups[i]);
        if (!pd) continue;
        seenCat[cat] = true;
        jobs.push({ cat: cat, pd: pd });
      }
  
      var mySession = kiwiState.session;
      var idx = 0;
      function next() {
        if (mySession !== kiwiState.session) return; // superseded by a newer run
        if (idx >= jobs.length) { finishSizeFinder(mySession); return; }
        var job = jobs[idx++];
        computeCategory(job.pd).then(function (size) {
          if (mySession !== kiwiState.session) return;
          if (size) kiwiState.sizes[job.cat] = size;
          next();
        });
      }
      next();
    }
  
    function finishSizeFinder(mySession) {
      if (mySession != null && mySession !== kiwiState.session) return;
      kiwiState.phase = 'idle';
      modalState.recommendedSizes = kiwiState.sizes;
      writeStoredSizing({
        sizes: kiwiState.sizes,
        height: kiwiState.height,
        weight: kiwiState.weight
      });
      if (kiwiHost) kiwiHost.innerHTML = ''; // drop leftovers, else the next run misreads them
      updateAllCards();
      applyRecommendations();
      updateSelectionUI();
    }
  
    // On open, re-pull each category from Kiwi's current profile (catches measurements
    // set via the PDP widget). An empty result keeps the stored value.
    function refreshFromProfile() {
      if (!window.ks || typeof window.ks.loadSizing !== 'function' || kiwiState.measuring) return;
      ensureKiwiSubscription();
      var mySession = ++kiwiState.session; // own session; a user click bumps it again → aborts this
      var prev = readStoredSizing() || {};
      var groups = getGroups();
      var idx = 0;
      function next() {
        if (mySession !== kiwiState.session) return; // superseded (e.g. user clicked "Finde meine Größe")
        if (idx >= groups.length) {
          writeStoredSizing({ sizes: modalState.recommendedSizes, height: prev.height || '', weight: prev.weight || '' });
          return;
        }
        var g = groups[idx++], cat = categoryOfGroup(g), pd = parseKiwiProduct(g);
        if (!cat || !pd) { next(); return; }
        computeCategory(pd).then(function (size) {
          if (mySession !== kiwiState.session) return;
          if (size) { modalState.recommendedSizes[cat] = size; applyRecommendations(); }
          next();
        });
      }
      next();
    }
  
    function startSizeFinder() {
      if (kiwiState.measuring) return; // Kiwi modal already open
      ensureKiwiSubscription();
      kiwiState.session++; // cancel any in-flight background refresh; this click takes over
      kiwiState.sizes = {};
      kiwiState.phase = 'source';
      kiwiState.pendingCategory = sourceCategory();
  
      // Open the source product's Kiwi recommender (the PDP's own button).
      var btn = document.querySelector(
        '.sizing-calculator-modal-button, .ks-calculator-modal-button'
      );
      if (btn) {
        // Step aside so Kiwi's (lower z-index) modal is visible; restore on its close.
        kiwiState.measuring = true;
        setConfiguratorVisible(false);
        btn.click();
        watchKiwiModal();
      } else {
        // No Kiwi widget on the page — nothing to drive.
        kiwiState.phase = 'idle';
      }
    }
  
    var sizeGuideLink = modal.querySelector('[data-sh-open-size-guide]');
    if (sizeGuideLink) {
      sizeGuideLink.addEventListener('click', function (event) {
        event.preventDefault();
        startSizeFinder();
      });
    }
  
    initCards();
  })();